import { t } from '../../../i18n/i18n';

/**
 * Logos for the payout rails — full-colour SVGs in `public/icons/`, so an
 * `<img>` rather than the `icon-mask` pattern: nothing here is recoloured.
 *
 * Rise and Wise are the brands' own marks, path for path, from the logos on
 * riseworks.io and wise.com. Each site inks its wordmark for a light page; on
 * these dark tiles Rise's goes white and Wise's takes the bright green Wise
 * itself uses on dark backgrounds. Bank Wire and Crypto are generic, drawn for
 * this page. Every wordmark is outlined, so the files don't depend on a font.
 *
 * Each is sized by height (see `.method-logo__brand--*`) so it keeps its own
 * proportions, optically matched across the four tiles.
 */
const LOGOS = {
  rise: { file: 'payout-rise', name: 'Rise' },
  wise: { file: 'payout-wise', name: 'Wise' },
  bank_wire: { file: 'payout-bank-wire', name: 'Bank wire' },
  crypto: { file: 'payout-crypto', name: 'Crypto' },
};

export default function MethodLogo({ id }) {
  const logo = LOGOS[id];
  if (!logo) return null;

  return (
    <span className="method-logo">
      <img
        className={`method-logo__brand method-logo__brand--${id}`}
        src={`/icons/${logo.file}.svg`}
        alt={t(logo.name)}
        draggable="false"
      />
    </span>
  );
}
